"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// 选择区域最小位移，小于这个值不会触发选择
var MIN_LIMIT = 10;
var Selection = /** @class */ (function () {
    function Selection(ctx) {
        /**
         * 缩放区对象
         */
        this.selection = null;
        this.data = {
            selecting: false,
            start: 0,
            end: 0,
        };
        // 是否启用选择
        this.enable = false;
        this.ctx = ctx;
        this.initMouseEvent();
    }
    Selection.prototype.setEnable = function (enable) {
        if (typeof enable === "boolean") {
            this.enable = enable;
            if (this.enable) {
                this.ctx.root.style("cursor", "crosshair");
            }
            else {
                this.ctx.root.style("cursor", "normal");
            }
        }
    };
    Selection.prototype.initMouseEvent = function () {
        var _this = this;
        // 监听鼠标拖拽事件
        this.ctx.on("container.mouse.down", function (x) {
            if (_this.enable) {
                _this.ctx.emit("selection.start", x);
                _this.data.start = x;
                _this.data.selecting = true;
            }
        });
        this.ctx.on("container.mouse.up", function (x) {
            if (_this.enable) {
                // 发送结束事件，传递 X 的范围
                if (_this.data.start < x) {
                    _this.data.end = x;
                }
                else {
                    _this.data.end = _this.data.start;
                    _this.data.start = x;
                }
                _this.data.selecting = false;
                _this.remove();
                if (_this.data.end - _this.data.start > MIN_LIMIT) {
                    _this.ctx.emit("selection.end", _this.data.start, _this.data.end);
                }
            }
        });
        this.ctx.on("plot.mouse.move", function (x) {
            if (_this.enable &&
                _this.data.selecting &&
                Math.abs(x - _this.data.start) > MIN_LIMIT) {
                _this.drawSelectionMarker(x);
            }
        });
    };
    /**
     * 绘制选择框
     * @param x 当前 x 的坐标
     */
    Selection.prototype.drawSelectionMarker = function (x) {
        var plotY = parseInt(this.ctx.plotBackgound.attr("y"), 10);
        var plotHeight = parseInt(this.ctx.plotBackgound.attr("height"), 10);
        var start = [this.data.start, plotY];
        var end = [x, plotHeight + plotY];
        this.draw(start, end);
    };
    Selection.prototype.draw = function (start, end) {
        var _a = this.ctx, root = _a.root, classPrefix = _a.classPrefix;
        if (!this.selection) {
            this.selection = root
                .append("rect")
                .attr("class", classPrefix + "-chart-selection-marker")
                .attr("fill", "rgba(51, 92, 173, 0.25)")
                .attr("data-z-index", "7");
        }
        var _b = tslib_1.__read(start, 2), startX = _b[0], startY = _b[1];
        var _c = tslib_1.__read(end, 2), endX = _c[0], endY = _c[1];
        this.selection
            .attr("x", startX > endX ? endX : startX)
            .attr("y", startY > endY ? endY : startY)
            .attr("height", Math.abs(startY - endY))
            .attr("width", Math.abs(startX - endX));
    };
    Selection.prototype.remove = function () {
        if (this.selection) {
            this.selection.remove();
            this.selection = null;
        }
    };
    return Selection;
}());
exports.Selection = Selection;
//# sourceMappingURL=selection.js.map